import styled from 'styled-components';
import BaseDropdown from '../../../../components/Dropdown';
import BaseTooltip from '../Tooltip';

export const Container = styled.div`
  width: 100%;
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ActionItem = styled.div`
  margin-right: 40px;

  &:last-child {
    margin-right: 0;
  }
`;

export const ActionLabel = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #748aa1;
  font-weight: 400;
  margin-bottom: 5px;
`;

export const Dropdown = styled(BaseDropdown)`
  & > div:first-child {
    border-radius: 4px;
    border-color: #d0d7e3;
    height: 24px;
    line-height: 18px;

    & > i {
      line-height: 18px;
    }
  }
`;

export const Tooltip = styled(BaseTooltip)`
  display: inline-block;
`;
